import routes from "actions/routes";
import { generateCreateActionCreator, generateDeleteActionCreator, generateReadActionCreator, generateReadOneActionCreator, generateUpdateActionCreator } from 'actions/crudActionCreators';
import ACTION_NAMES from 'actions/ACTION_NAMES';

const getBrand = generateReadActionCreator(routes.API_TCR_BRAND, ACTION_NAMES.TCR_BRAND);
const createBrand = generateCreateActionCreator(routes.API_TCR_BRAND, ACTION_NAMES.TCR_BRAND);
const updateBrand = generateUpdateActionCreator(routes.API_TCR_BRAND, ACTION_NAMES.TCR_BRAND);
const createBrandCampaign = generateCreateActionCreator(routes.API_TCR_CAMPAIGN, ACTION_NAMES.TCR_CAMPAIGN);
const saveBrandCampaign = generateCreateActionCreator(`${routes.API_TCR_CAMPAIGN}/save`, ACTION_NAMES.TCR_CAMPAIGN_SAVE);
const getBrandCampaigns = generateReadActionCreator(routes.API_TCR_CAMPAIGN, ACTION_NAMES.TCR_CAMPAIGN);
const getBrandCampaign = generateReadOneActionCreator(routes.API_TCR_CAMPAIGN, ACTION_NAMES.TCR_CAMPAIGN);
const updateBrandCampaign = generateUpdateActionCreator(routes.API_TCR_CAMPAIGN, ACTION_NAMES.TCR_CAMPAIGN);
const deleteBrandCampaign = generateDeleteActionCreator(routes.API_TCR_CAMPAIGN, ACTION_NAMES.TCR_CAMPAIGN);
const assignTcrCampaignSlot = generateUpdateActionCreator(`${routes.API_TCR_CAMPAIGN}/assign_slot`, ACTION_NAMES.TCR_CAMPAIGN_ASSIGN_SLOT);
const deleteTcrCampaignSlot = generateDeleteActionCreator(`${routes.API_TCR_CAMPAIGN}/delete_slot`, ACTION_NAMES.TCR_CAMPAIGN_DELETE_SLOT);
const getBrandOptOutStatus = generateReadOneActionCreator(`${routes.API_TCR_BRAND}`, ACTION_NAMES.TCR_BRAND_OPT_OUT_STATUS, "optout");
const updateBrandOptOutStatus = generateUpdateActionCreator(`${routes.API_TCR_BRAND}`, ACTION_NAMES.TCR_BRAND_OPT_OUT_STATUS,()=>{},()=>{},"optout");

export default {
    getBrand,
    createBrand,
    updateBrand,
    createBrandCampaign,
    saveBrandCampaign,
    getBrandCampaigns,
    getBrandCampaign,
    updateBrandCampaign,
    deleteBrandCampaign,
    assignTcrCampaignSlot,
    deleteTcrCampaignSlot,
    getBrandOptOutStatus,
    updateBrandOptOutStatus
}
